module.exports = __webpack_public_path__ + "static/media/locked-outline.a9213b9a.svg";